var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8553 30.2651C20.2513 30.2651 23.5082 28.8604 25.9095 26.3599C28.3108 23.8594 29.6599 20.468 29.6599 16.9318C29.6599 13.3956 28.3108 10.0042 25.9095 7.50371C23.5082 5.00323 20.2513 3.59847 16.8553 3.59847C13.4593 3.59847 10.2024 5.00323 7.80112 7.50371C5.3998 10.0042 4.05075 13.3956 4.05075 16.9318C4.05075 20.468 5.3998 23.8594 7.80112 26.3599C10.2024 28.8604 13.4593 30.2651 16.8553 30.2651ZM16.8553 33.5985C8.01536 33.5985 0.849609 26.1368 0.849609 16.9318C0.849609 7.7268 8.01536 0.265137 16.8553 0.265137C25.6952 0.265137 32.861 7.7268 32.861 16.9318C32.861 26.1368 25.6952 33.5985 16.8553 33.5985Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_2692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_2692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H24V24H10V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_2692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.025 10.6558H23.172L18.482 16.0298L24 23.3438H19.68L16.294 18.9088L12.424 23.3438H10.275L15.291 17.5938L10 10.6568H14.43L17.486 14.7098L21.025 10.6558ZM20.27 22.0558H21.46L13.78 11.8768H12.504L20.27 22.0558Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_2692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dddd26eeab76c7339d7b911d60a81831.svg";
export { ForwardRef as ReactComponent };